import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule, CmsConfig } from '@spartacus/core';
import { KnBrQuoteDeleteItemsComponent } from './kn-br-quote-delete-items.component';

@NgModule({
    imports: [
        CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrQuoteDeleteItemsComponent: {
                    component: KnBrQuoteDeleteItemsComponent,
                },
            },
        } as CmsConfig),
        KnBrQuoteDeleteItemsComponent,
    ],
})
export class KnBrQuoteDeleteItemsModule {}
